import { toast } from 'vue3-toastify';

export const config = {
  autoClose: 3000,
  icon: false,
  position: toast.POSITION.BOTTOM_RIGHT,
  transition: toast.TRANSITIONS.SLIDE,
};
